<style lang="scss">
  @import 'styles.scss';
  @import 'styles.sass';
</style>

<template>
  <div id="app" class="app-main">
    <v-app>
      <snackbar-update :hashChanged="hashChanged" @reloadApp="reloadApp"/>
      <snackbar/>

      <router-view/>
      <v-overlay :value="preloaderApp" z-index="11" id="main-overlay" opacity="0">
        <v-layout align-center justify-center class="mb-2">
          <v-img
              src="/logo.png"
              lazy-src="/logo.png"
              height="50"
              max-width="190"
              contain
          ></v-img>
        </v-layout>
        <v-layout align-center justify-center>
          <v-progress-linear indeterminate color="primary" height="5"></v-progress-linear>
        </v-layout>
      </v-overlay>
    </v-app>
  </div>
</template>

<script>
import {refreshPageMixin} from '@/plugins/refresh-page.mixins';
import Cookies from 'js-cookie';

export default {
  name: 'App',
  components: {},
  mixins: [refreshPageMixin],
  data() {
    return {}
  },
  created() {
    window.addEventListener('focus', this.focus);
    window.addEventListener('blur', this.blur);
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    });
    this.initVersionCheck('/version.json');
    setTimeout(() => this.$store.commit('SET_PRELOADER_APP', false), 1000)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('focus', this.focus);
    window.removeEventListener('blur', this.blur);
  },
  computed: {
    preloaderApp() {
      return this.$store.state.app.preloaderApp;
    },
    token() {
      return this.$store.state.user.token;
    },
  },
  watch: {
    token(val) {
      if (val) this.$store.dispatch('getMe')

      // if (val) {
      //   this.getMe();
      // } else {
      //   clearInterval(this._timer1);
      // }
    }
  },
  methods: {
    onResize() {
      this.$store.commit('SET_WINDOW_WIDTH', window.innerWidth)
    },
    focus() {
      this.$store.commit('SET_WINDOW_ACTIVE', true);
    },
    blur() {
      this.$store.commit('SET_WINDOW_ACTIVE', false);
    },
    init() {
      if (Cookies.get('RTT')) {
        this.$store.dispatch('getMe')
            .then(() => {
              setTimeout(() => this.$store.commit('SET_PRELOADER_APP', false), 1000);
              // setTimeout(() => this.getMe(), 1000 * 60 * 0.5);
            })
            // .catch(() => clearInterval(this._timer1))
      } else {
        setTimeout(() => this.$store.commit('SET_PRELOADER_APP', false), 1000)
      }
    },
    // getMe() {
    //   clearInterval(this._timer1);
    //   this.$store.dispatch('getMe')
    //       .catch(() => clearInterval(this._timer1))
    //   this._timer1 = setInterval(() => {
    //     this.$store.dispatch('getMe')
    //         .catch(() => clearInterval(this._timer1))
    //   }, 1000 * 60 * 1)
    // },
  }
}
</script>
